import { render, staticRenderFns } from "./xsmYinLiuDialog.vue?vue&type=template&id=7e4b0cc2&scoped=true&"
import script from "./xsmYinLiuDialog.vue?vue&type=script&lang=js&"
export * from "./xsmYinLiuDialog.vue?vue&type=script&lang=js&"
import style0 from "./xsmYinLiuDialog.vue?vue&type=style&index=0&id=7e4b0cc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4b0cc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e4b0cc2')) {
      api.createRecord('7e4b0cc2', component.options)
    } else {
      api.reload('7e4b0cc2', component.options)
    }
    module.hot.accept("./xsmYinLiuDialog.vue?vue&type=template&id=7e4b0cc2&scoped=true&", function () {
      api.rerender('7e4b0cc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/insurance/xsmYinLiuDialog.vue"
export default component.exports